import { DisplayMode, OperationType, PayMethod } from 'cbc-shared-lib';

export const sgkz001dConfig = [
  {
    itemId: '',
    title: '包括契約',
    pathInfo: {
      path: '',
      mode: '',
      operationType: '',
    },
    children: [
      {
        itemId: 'inclusioncontractReg',
        title: '包括契約登録',
        pathInfo: {
          path: '/sgkb/sgkb708d/',
          mode: DisplayMode.create,
          operationType: '',
        },
        children: []
      },
      {
        itemId: 'termCtrchg',
        title: '期中契約変更（需給契約の追加・解除）',
        pathInfo: {
          path: '/sgkb/sgkb701d/',
          mode: DisplayMode.update,
          operationType: OperationType.midterm_change,
        },
        children: []
      },
      {
        itemId: 'ctrrenewal',
        title: '契約更改',
        pathInfo: {
          path: '/sgkb/sgkb701d/',
          mode: DisplayMode.update,
          operationType: OperationType.renewal,
        },
        children: []
      },
      {
        itemId: 'inclusioncontractBreak',
        title: '包括契約解約',
        pathInfo: {
          path: '/sgkb/sgkb701d/',
          mode: DisplayMode.update,
          operationType: OperationType.cancel,
        },
        children: []
      },
      {
        itemId: 'inclusioncontractApprv',
        title: '包括契約承認',
        pathInfo: {
          path: '/sgkb/sgkb701d/',
          mode: DisplayMode.approve,
          operationType: '',
        },
        children: []
      },
      {
        itemId: 'inclusioncontractCancel',
        title: '包括契約取消',
        pathInfo: {
          path: '/sgkb/sgkb701d/',
          mode: DisplayMode.delete,
          operationType: '',
        },
        children: []
      },
      {
        itemId: 'inclusioncontractRef',
        title: '包括契約照会',
        pathInfo: {
          path: '/sgkb/sgkb701d/',
          mode: DisplayMode.read,
          operationType: '',
        },
        children: []
      }
    ]
  },
  {
    itemId: '',
    title: '単価表',
    path: '',
    children: [
      {
        itemId: 'tankatableReg',
        title: '単価表登録',
        pathInfo: {
          path: '/sgkc/sgkc021d/',
          mode: DisplayMode.create,
          operationType: '',
        },
        children: []
      },
      {
        itemId: 'tankatableCancel',
        title: '単価表取消',
        pathInfo: {
          path: '/sgkc/sgkc021d/',
          mode: DisplayMode.delete,
          operationType: '',
        },
        children: []
      },
      {
        itemId: 'tankatableApprv',
        title: '単価表承認',
        pathInfo: {
          path: '/sgkc/sgkc021d/',
          mode: DisplayMode.approve,
          operationType: '',
        },
        children: []
      },
      {
        itemId: 'tankatableReference',
        title: '単価表参照',
        pathInfo: {
          path: '/sgkc/sgkc021d/',
          mode: DisplayMode.read,
          operationType: '',
        },
        children: []
      },
      {
        itemId: 'referencetableOutputtarget',
        title: '早見表出力',
        pathInfo: {
          path: '/sgkc/sgkc041d/',
          mode: '',
          operationType: '',
        },
        children: []
      }
    ]
  },
  {
    itemId: '',
    title: 'スライド調整単価',
    path: '',
    children: [
      {
        itemId: 'slideadjustmentunitpriceReg',
        title: 'スライド調整単価登録',
        pathInfo: {
          path: '/sgkc/sgkc031d/',
          mode: DisplayMode.create,
          operationType: '',
        },
        children: []
      },
      {
        itemId: 'slideadjustmentunitpriceCancel',
        title: 'スライド調整単価取消',
        pathInfo: {
          path: '/sgkc/sgkc031d/',
          mode: DisplayMode.delete,
          operationType: '',
        },
        children: []
      },
      {
        itemId: 'slideadjustmentunitpriceApprv',
        title: 'スライド調整単価承認',
        pathInfo: {
          path: '/sgkc/sgkc031d/',
          mode: DisplayMode.approve,
          operationType: '',
        },
        children: []
      },
      {
        itemId: 'slideadjustmentunitpriceReference',
        title: 'スライド調整単価参照',
        pathInfo: {
          path: '/sgkc/sgkc031d/',
          mode: DisplayMode.read,
          operationType: '',
        },
        children: []
      }
    ]
  },
  {
    itemId: '',
    title: '再エネ賦課金単価',
    path: '',
    children: [
      {
        itemId: 'redtaxTankaReg',
        title: '再エネ賦課金単価登録',
        pathInfo: {
          path: '/sgkc/sgkc034d/',
          mode: DisplayMode.create,
          operationType: '',
        },
        children: []
      },
      {
        itemId: 'redtaxTankaCancel',
        title: '再エネ賦課金単価取消',
        pathInfo: {
          path: '/sgkc/sgkc034d/',
          mode: DisplayMode.delete,
          operationType: '',
        },
        children: []
      },
      {
        itemId: 'redtaxTankaApprv',
        title: '再エネ賦課金単価承認',
        pathInfo: {
          path: '/sgkc/sgkc034d/',
          mode: DisplayMode.approve,
          operationType: '',
        },
        children: []
      },
      {
        itemId: 'redtaxTankaReference',
        title: '再エネ賦課金単価参照',
        pathInfo: {
          path: '/sgkc/sgkc034d/',
          mode: DisplayMode.read,
          operationType: '',
        },
        children: []
      }
    ]
  },
  {
    itemId: '',
    title: '使用量',
    path: '',
    children: [
      {
        itemId: 'fixempReImport',
        title: '確定使用量再取込',
        pathInfo: {
          path: '/sgkc/sgkc051d/',
          mode: '',
          operationType: '',
        },
        children: []
      }
    ]
  },
  {
    itemId: '',
    title: '請求',
    path: '',
    children: [
      {
        itemId: 'accounttransfercreditapplicationformIkkatuPrint',
        title: '口座振替・クレジット申込書一括印刷',
        pathInfo: {
          path: '/sgkd/sgkd004d',
          mode: '',
          operationType: '',
        },
        children: []
      },
      {
        itemId: 'kohuriReqestreturndetailstableOutput',
        title: '口座振替依頼返却内訳表出力',
        pathInfo: {
          path: '/sgkd/sgkd010d',
          mode: '',
          operationType: '',
        },
        children: []
      },
      {
        itemId: 'addresseePrint',
        title: '宛名印刷',
        pathInfo: {
          path: '/sgkd/sgkd019d',
          mode: '',
          operationType: '',
        },
        children: []
      },
      {
        itemId: 'accountTransferApplicationReception',
        title: '口座振替申込受付',
        pathInfo: {
          path: '/sgkd/sgkd020d',
          mode: '',
          operationType: '',
          payMethod: PayMethod.account,
        },
        children: []
      },
      {
        itemId: 'creditApplicationReception',
        title: 'クレジット申込受付',
        pathInfo: {
          path: '/sgkd/sgkd020d',
          mode: '',
          operationType: '',
          payMethod: PayMethod.credit,
        },
        children: []
      }
    ]
  },
  {
    itemId: '',
    title: '速報取消',
    path: '',
    children: [
      {
        itemId: 'realtimeCancel',
        title: '速報取消',
        pathInfo: {
          path: '/sgke/sgke100d/',
          mode: DisplayMode.create,
          operationType: '',
        },
        children: []
      },
      {
        itemId: 'realtimeCancelApprv',
        title: '速報取消承認',
        pathInfo: {
          path: '/sgke/sgke100d/',
          mode: DisplayMode.approve,
          operationType: '',
        },
        children: []
      }
    ]
  },
  {
    itemId: '',
    title: '入金突合',
    path: '',
    children: [
      {
        itemId: 'rcvmnyTutiReport',
        title: '入金通知報告',
        pathInfo: {
          path: '/sgke/sgke110d/',
          mode: '',
          operationType: '',
        },
        children: []
      },
      {
        itemId: 'feeReport',
        title: '手数料報告',
        pathInfo: {
          path: '/sgke/sgke140d',
          mode: '',
          operationType: '',
        },
        children: []
      },
      {
        itemId: 'rcvmnyReconciliation',
        title: '入金突合',
        pathInfo: {
          path: '/sgke/sgke120d/',
          mode: DisplayMode.create,
          operationType: '',
        },
        children: []
      },
      {
        itemId: 'rcvmnyReconciliationApprv',
        title: '入金突合承認',
        pathInfo: {
          path: '/sgke/sgke120d/',
          mode: DisplayMode.approve,
          operationType: '',
        },
        children: []
      },
      {
        itemId: 'rcvmnyClsingReg',
        title: '入金締め登録',
        pathInfo: {
          path: '/sgke/sgke160d/',
          mode: DisplayMode.create,
          operationType: '',
        },
        children: []
      },
      {
        itemId: 'rcvmnyClsingApprv',
        title: '入金締め承認',
        pathInfo: {
          path: '/sgke/sgke160d/',
          mode: DisplayMode.approve,
          operationType: '',
        },
        children: []
      },
      {
        itemId: 'rcvmnyReporttable',
        title: '入金報告表',
        pathInfo: {
          path: '/sgke/sgke150d',
          mode: '',
          operationType: '',
        },
        children: []
      }
    ]
  },
  {
    itemId: '',
    title: '未精算',
    path: '',
    children: [
      {
        itemId: 'kinkoOrganizeRef',
        title: '未精算整理照会',
        pathInfo: {
          path: '/sgke/sgke010d',
          mode: '',
          operationType: '',
        },
        children: []
      },
      {
        itemId: 'kinkoRelatedApprv',
        title: '未精算関連承認',
        pathInfo: {
          path: '/sgke/sgke090d',
          mode: '',
          operationType: '',
        },
        children: []
      },
      {
        itemId: 'depFriimpReg',
        title: '預り金振替不能登録',
        pathInfo: {
          path: '/sgke/sgke080d',
          mode: '',
          operationType: '',
        },
        children: []
      }
    ]
  },
  {
    itemId: '',
    title: '収納',
    path: '',
    children: [
      {
        itemId: 'receivableVisitSearch',
        title: '未収お客さま検索',
        pathInfo: {
          path: '/sgke/sgke300d',
          mode: '',
          operationType: '',
        },
        children: []
      },
      {
        itemId: 'supplystopPlndateSearch',
        title: '供給停止予定検索',
        pathInfo: {
          path: '/sgke/sgke310d',
          mode: '',
          operationType: '',
        },
        children: []
      },
      {
        itemId: 'supplystopWorkassignment',
        title: '供給停止作業割当',
        pathInfo: {
          path: '/sgke/sgke320d',
          mode: '',
          operationType: '',
        },
        children: []
      },
      {
        itemId: 'supplyresumptionWorkassignment',
        title: '供給再開作業割当',
        pathInfo: {
          path: '/sgke/sgke350d',
          mode: '',
          operationType: '',
        },
        children: []
      },
      {
        itemId: 'tantoWorkLst',
        title: '担当作業一覧',
        pathInfo: {
          path: '/sgke/sgke330d',
          mode: '',
          operationType: '',
        },
        children: []
      }
    ]
  },
  {
    itemId: '',
    title: 'サービサー',
    path: '',
    children: [
      {
        itemId: 'servicerConsignmenttargetSearch',
        title: 'サービサー委託対象検索',
        pathInfo: {
          path: '/sgke/sgke380d/',
          mode: DisplayMode.create,
          operationType: '',
        },
        children: []
      },
      {
        itemId: 'servicerReturnSearch',
        title: 'サービサー返却検索',
        pathInfo: {
          path: '/sgke/sgke380d/',
          mode: DisplayMode.update,
          operationType: '',
        },
        children: []
      }
    ]
  },
  {
    itemId: '',
    title: '欠損',
    path: '',
    children: [
      {
        itemId: 'lossScdLst',
        title: '欠損予定一覧',
        pathInfo: {
          path: '/sgke/sgke400d/',
          mode: DisplayMode.create,
          operationType: '',
        },
        children: []
      },
      {
        itemId: 'lossApprv',
        title: '欠損承認',
        pathInfo: {
          path: '/sgke/sgke410d',
          mode: '',
          operationType: '',
        },
        children: []
      },
      {
        itemId: 'lossFinalApprv',
        title: '欠損最終承認',
        pathInfo: {
          path: '/sgke/sgke400d/',
          mode: DisplayMode.approve,
          operationType: '',
        },
        children: []
      }
    ]
  },
  {
    itemId: '',
    title: '共通',
    path: '',
    children: [
      {
        itemId: 'fileDownload',
        title: 'ファイルダウンロード',
        pathInfo: {
          path: '/sgkd/sgkd017d',
          mode: '',
          operationType: '',
        },
        children: []
      }
    ]
  }
];
